export default __webpack_public_path__ + "b415a0728fc681be97b7b69362ee84ec.svg";